import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';

export const messageHistoryKey = (id: string, scope = sessionScope(useAuthStore.getState())) => ['message', id, 'edits', scope] as const;
export const currentMessageHistoryKey = (key: readonly unknown[]) => key.length === 4 && key[0] === 'message' && key[2] === 'edits' && key[3] === sessionScope(useAuthStore.getState());
